// ===============================================================
// assets/oryx-configurator.js
// ===============================================================

function degToRad(deg) {
  return (deg * Math.PI) / 180;
}

const FOLD_GROUP = 'Klingenstahl';
const BLADE_HINGE_WORLD = new BABYLON.Vector3(0.035, 0.19, 0.04);
const PREVIEW_STEP_NAME = 'Vorschau';
let defaultBladeModelUrl = null;
const MOBILE_FULLSCREEN_SEEN_KEY = 'oryx_mobile_fullscreen_seen';

function getDatasetBladePivot(dataset) {
  const defaultPivot = BLADE_HINGE_WORLD;
  const pivotX = toFiniteNumber(dataset.bladePivotX, Number.NaN);
  const pivotY = toFiniteNumber(dataset.bladePivotY, Number.NaN);
  const pivotZ = toFiniteNumber(dataset.bladePivotZ, Number.NaN);
  const hasAnyCustomPivot = [pivotX, pivotY, pivotZ].some(Number.isFinite);

  if (!hasAnyCustomPivot) {
    return null;
  }

  return new BABYLON.Vector3(
    Number.isFinite(pivotX) ? pivotX : defaultPivot.x,
    Number.isFinite(pivotY) ? pivotY : defaultPivot.y,
    Number.isFinite(pivotZ) ? pivotZ : defaultPivot.z
  );
}

function getBladePivotWorld() {
  const container = document.getElementById('configurator-container');
  const dataset = container?.dataset || {};
  const datasetPivot = getDatasetBladePivot(dataset);
  if (datasetPivot) return datasetPivot;

  return BLADE_HINGE_WORLD.clone();
}

function toFiniteNumber(value, fallback = 0) {
  const numString = value?.toString?.().replace(',', '.');
  const num = Number(numString);
  return Number.isFinite(num) ? num : fallback;
}

function setBladePivot(root, pivotWorld) {
  if (!root || !pivotWorld) return;

  const pivotLocal = pivotWorld.subtract(root.position).divide(root.scaling);
  const worldPosBeforePivot = root.getAbsolutePosition().clone();
  root.setPivotPoint(pivotLocal);
  root.setAbsolutePosition(worldPosBeforePivot);
}

function getEngravingConfig() {
  const container = document.getElementById('configurator-container');
  const dataset = container?.dataset || {};

  const position = new BABYLON.Vector3(
    toFiniteNumber(dataset.engravingPosX),
    toFiniteNumber(dataset.engravingPosY),
    toFiniteNumber(dataset.engravingPosZ)
  );

  const rotationDeg = new BABYLON.Vector3(
    toFiniteNumber(dataset.engravingRotX),
    toFiniteNumber(dataset.engravingRotY),
    toFiniteNumber(dataset.engravingRotZ)
  );

  return {
    position,
    rotationDeg,
    planeWidth: toFiniteNumber(dataset.engravingPlaneWidth),
    planeHeight: toFiniteNumber(dataset.engravingPlaneHeight)
  };
}

function resolveDefaultBladeModelUrl() {
  if (defaultBladeModelUrl) {
    return defaultBladeModelUrl;
  }

  const container = document.getElementById('configurator-container');
  defaultBladeModelUrl = container?.dataset?.defaultBladeModelUrl || defaultBladeModelUrl;
  return defaultBladeModelUrl;
}

const DEFAULT_TRANSLATIONS = {
  controls: {
    fullscreen: 'Vollbild',
    exit_fullscreen: 'Vollbild verlassen',
    reset: 'Ansicht zurücksetzen',
    debug_show: 'Debug anzeigen',
    debug_hide: 'Debug ausblenden',
    rotation_start: 'Rotation starten',
    rotation_stop: 'Rotation stoppen',
    ar: 'In AR ansehen',
    add_to_cart: 'In den Warenkorb'
  },
  preview: {
    step_title: 'Bereit zum Teilen?',
    step_body: 'Sichere dir ein Bild deiner Konfiguration oder teile es direkt mit deiner Community.',
    download: 'Bild speichern',
    share: 'Dein Meisterwerk teilen',
    hint: 'Tipp: Auf Mobilgeräten öffnet sich beim Teilen automatisch der Instagram-Dialog.',
    download_filename: 'oryx-konfiguration.png',
    share_title: 'Meine ORYX Messer-Konfiguration',
    share_text: 'Schau dir meine individuelle ORYX Messer-Konfiguration an!'
  },
  messages: {
    preview_download_failed: 'Die Vorschau konnte nicht als Bild erzeugt werden. Bitte versuche es erneut.',
    preview_not_ready: 'Die Vorschau ist noch nicht bereit. Bitte warte einen Moment.',
    share_instagram_unsupported: 'Teilen über Instagram wird von diesem Gerät nicht unterstützt. Das Bild wurde gespeichert, damit du es manuell hochladen kannst.',
    share_file_unsupported: 'Dein Browser unterstützt das Teilen dieser Datei nicht.',
    share_fallback: 'Teilen wird nicht unterstützt. Das Bild wurde stattdessen gespeichert.',
    unknown_cart_error: 'Unbekannter Fehler beim Hinzufügen zum Warenkorb.',
    missing_step: 'Konnte nicht zum Warenkorb hinzugefügt werden… Es fehlt Step {{ step }}',
    add_to_cart_failed: 'Der Konfigurator konnte nicht in den Warenkorb gelegt werden. Bitte prüfe deine Auswahl und versuche es erneut.',
    unknown_step: 'unbekannter Schritt',
    surcharge_fallback: 'Der Aufpreis konnte nicht automatisch berechnet werden. Der Basisartikel wird ohne Aufpreis in den Warenkorb gelegt.',
    ar_not_supported: 'AR wird auf diesem Gerät nicht unterstützt.',
    ar_launch_failed: 'AR konnte nicht gestartet werden. Bitte versuche es erneut.',
    ar_preparing: 'AR wird vorbereitet …',
    ar_open_native: 'Öffne native AR-Ansicht …',
    ar_place_hint: 'Bewege dein Gerät und tippe, um das Messer zu platzieren.',
    ar_drag_place_hint: 'Bewege den Gelben Kreis auf eine gerade Fläche. Tippe dann drauf, um das Messer zu platzieren.',
    ar_mobile_only: 'Nur auf dem Handy verfügbar.',
    ar_mode_webxr: 'Starte WebXR-Modus …',
    ar_mode_quicklook: 'Öffne native Quick Look AR-Ansicht …',
    ar_mode_scene_viewer: 'Öffne Android Scene Viewer …',
    ar_session_ended: 'AR wurde beendet.'
  },
  empty_options: 'Keine Optionen verfügbar',
  engraving: {
    label: 'Dein Gravurtext',
    placeholder: 'Max. 20 Zeichen'
  },
  mobile_fullscreen: {
    title: 'Bitte aktiviere Vollbild und drehe dein Smartphone',
    body: 'Im Vollbild und im Querformat läuft der Konfigurator am flüssigsten.',
    primary: 'Jetzt Vollbild & drehen',
    skip: 'Ohne Vollbild fortfahren (nicht empfohlen)'
  },
  groups: {}
};

function getOryxTranslations() {
  const script = document.getElementById('oryx-translations');
  if (!script) return {};
  try {
    return JSON.parse(script.textContent) || {};
  } catch (error) {
    console.warn('ORYX Konfigurator: Konnte Übersetzungen nicht parsen.', error);
    return {};
  }
}

function buildTranslations() {
  const incoming = getOryxTranslations();
  const merged = { ...DEFAULT_TRANSLATIONS };

  ['controls', 'preview', 'messages', 'engraving', 'mobile_fullscreen', 'groups'].forEach(key => {
    if (incoming[key]) {
      merged[key] = { ...merged[key], ...incoming[key] };
    }
  });

  if (incoming.empty_options) {
    merged.empty_options = incoming.empty_options;
  }

  return merged;
}

const translations = buildTranslations();
let mobileFullscreenDismissed = false;

function translate(path) {
  const segments = path.split('.');
  let current = translations;
  for (const segment of segments) {
    if (current == null) return path;
    current = current[segment];
  }
  return typeof current === 'undefined' ? path : current;
}

function translateGroupName(groupName) {
  if (!groupName) return '';
  return translations.groups?.[groupName] || groupName;
}

function markMobileFullscreenSeen() {
  try {
    window.localStorage?.setItem(MOBILE_FULLSCREEN_SEEN_KEY, '1');
  } catch (error) {
    console.warn('ORYX Konfigurator: localStorage nicht verfügbar.', error);
  }
}

function hasSeenMobileFullscreenHint() {
  try {
    return window.localStorage?.getItem(MOBILE_FULLSCREEN_SEEN_KEY) === '1';
  } catch (error) {
    console.warn('ORYX Konfigurator: localStorage nicht verfügbar.', error);
    return false;
  }
}

const PREVIEW_DOWNLOAD_FILENAME = translate('preview.download_filename');
const modelPreloadCache = new Set();
const arMode = window.OryxConfiguratorArMode
  ? window.OryxConfiguratorArMode.create({
    translate,
    animateCameraToInitial,
    getPreviewCanvas
  })
  : null;

function isMobileDevice() {
  if (arMode?.isMobileDevice) {
    return arMode.isMobileDevice();
  }
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(navigator.userAgent || '');
}

function isAndroid() {
  if (arMode?.isAndroid) {
    return arMode.isAndroid();
  }
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (/Android/i).test(navigator.userAgent || '');
}

function isIos() {
  if (arMode?.isIos) {
    return arMode.isIos();
  }
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (/iPad|iPhone|iPod/i).test(navigator.userAgent || '');
}

async function detectARCapability() {
  if (typeof navigator === 'undefined') {
    return 'none';
  }

  const container = document.getElementById('configurator-container');
  const glbUrl = container?.dataset?.arGlbUrl;
  const usdzUrl = container?.dataset?.arUsdzUrl;
  const isIosDevice = isIos();
  const isAndroidDevice = isAndroid();

  if (navigator.xr?.isSessionSupported) {
    try {
      const immersiveSupported = await navigator.xr.isSessionSupported('immersive-ar');
      if (immersiveSupported) {
        return 'webxr';
      }
    } catch (error) {
      console.warn('WebXR capability check failed', error);
    }
  }

  if (isIosDevice && usdzUrl) {
    return 'ios-native';
  }
  if (isAndroidDevice && glbUrl) {
    return 'android-native';
  }

  return 'none';
}

function preloadModelFile(url) {
  if (!url || modelPreloadCache.has(url)) {
    return;
  }
  modelPreloadCache.add(url);
  try {
    fetch(url, { method: 'GET', mode: 'no-cors', cache: 'force-cache', keepalive: true })
      .catch(() => { /* Ignorieren – Warmup ohne Blocker */ });
  } catch (error) {
    console.debug('Preload nicht möglich für', url, error);
  }
}

const CAMERA_FOCUS_CONFIG = {
  Klingenstahl: {
    beta: degToRad(70),
    radius: 4.6,
    target: new BABYLON.Vector3(0.08, 0.6, 2.5)
  },
  Griffmaterial: {
    beta: degToRad(68),
    radius: 4.6,
    target: new BABYLON.Vector3(0, 0.65, -2.5)
  },
  Feder: {
    alpha: degToRad(180),
    beta: degToRad(20),
    radius: 4.5,
    target: new BABYLON.Vector3(0.005, 0.9, -1.8)
  },
  Ring: {
    alpha: degToRad(180),
    beta: degToRad(78),
    radius: 2.4,
    target: new BABYLON.Vector3(0.03, 1.55, 0.18)
  },
  Schraube: {
    alpha: degToRad(200),
    beta: degToRad(55),
    radius: 2.3,
    target: new BABYLON.Vector3(0.035, 0.19, 0.04)
  },
  Niete: {
    alpha: degToRad(160),
    beta: degToRad(50),
    radius: 2.4,
    target: new BABYLON.Vector3(0, 0.33, -2.45)
  }
};
const pricingState = {
  basePriceCents: 0,
  activeBasePriceCents: 0,
  surchargeCents: 0,
  totalCents: 0,
  selections: [],
  summary: '',
  variantId: null
};
let surchargeVariantWarningShown = false;

const ENGRAVING_TEXTURE_SIZE = { width: 1024, height: 256 };
const IDLE_ROTATION_DELAY_MS = 7000;
const IDLE_ROTATION_SPEED = degToRad(8); // degrees per second converted to radians

function getPreviewCanvas(viewerObj = viewer) {
  if (!viewerObj || !viewerObj.engine || typeof viewerObj.engine.getRenderingCanvas !== 'function') {
    return null;
  }
  return viewerObj.engine.getRenderingCanvas();
}

async function capturePreviewDataUrl(viewerObj = viewer, { preferHighRes = true } = {}) {
  const canvas = getPreviewCanvas(viewerObj);
  if (!canvas) {
    return null;
  }

  const fallbackDataUrl = typeof canvas.toDataURL === 'function'
    ? canvas.toDataURL('image/png', 0.92)
    : null;

  if (
    preferHighRes
    && viewerObj?.engine
    && viewerObj?.camera
    && typeof BABYLON?.Tools?.CreateScreenshotUsingRenderTarget === 'function'
  ) {
    const measuredWidth = Number.isFinite(canvas.width)
      ? canvas.width
      : Math.round(canvas.clientWidth * (window.devicePixelRatio || 1));
    const measuredHeight = Number.isFinite(canvas.height)
      ? canvas.height
      : Math.round(canvas.clientHeight * (window.devicePixelRatio || 1));
    const baseWidth = Number.isFinite(measuredWidth) && measuredWidth > 0 ? measuredWidth : 0;
    const baseHeight = Number.isFinite(measuredHeight) && measuredHeight > 0 ? measuredHeight : 0;
    const aspectRatio = baseWidth > 0 && baseHeight > 0 ? baseHeight / baseWidth : 1;

    const targetWidth = Math.max(
      Math.round(((baseWidth || canvas.clientWidth || 960) * 2)),
      1920
    );
    const targetHeight = Math.max(
      Math.round(targetWidth * aspectRatio),
      baseHeight > 0 ? Math.round(baseHeight * 2) : 0
    );
    const screenshotSize = {
      width: targetWidth,
      height: targetHeight || targetWidth
    };

    try {
      const dataUrl = await new Promise(resolve => {
        BABYLON.Tools.CreateScreenshotUsingRenderTarget(
          viewerObj.engine,
          viewerObj.camera,
          screenshotSize,
          result => resolve(result || null),
          'image/png'
        );
      });
      if (dataUrl) {
        return dataUrl;
      }
    } catch (error) {
      console.warn('ORYX Konfigurator: Hochauflösender Screenshot fehlgeschlagen.', error);
    }
  }

  return fallbackDataUrl;
}

async function downloadPreviewImage(filename = PREVIEW_DOWNLOAD_FILENAME, viewerObj = viewer) {
  const dataUrl = await capturePreviewDataUrl(viewerObj);
  if (!dataUrl) {
    alert(translate('messages.preview_download_failed'));
    return false;
  }
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  requestAnimationFrame(() => link.remove());
  return true;
}

function dataUrlToBlob(dataUrl) {
  try {
    const parts = dataUrl.split(',');
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/png';
    const binary = atob(parts[1]);
    const len = binary.length;
    const array = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type: mime });
  } catch (error) {
    console.warn('dataUrlToBlob failed', error);
    return null;
  }
}

async function sharePreviewImageOnInstagram(viewerObj = viewer) {
  const dataUrl = await capturePreviewDataUrl(viewerObj);
  if (!dataUrl) {
    alert(translate('messages.preview_not_ready'));
    return false;
  }
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
    const downloadSuccess = await downloadPreviewImage(PREVIEW_DOWNLOAD_FILENAME, viewerObj);
    if (downloadSuccess) {
      alert(translate('messages.share_instagram_unsupported'));
    }
    return downloadSuccess;
  }

  const blob = dataUrlToBlob(dataUrl);
  if (!blob) {
    alert(translate('messages.share_instagram_unsupported'));
    return false;
  }

  if (typeof File === 'undefined') {
    alert(translate('messages.share_file_unsupported'));
    return false;
  }

  const shareFile = new File([blob], PREVIEW_DOWNLOAD_FILENAME, { type: 'image/png' });
  if (navigator.canShare && !navigator.canShare({ files: [shareFile] })) {
    const downloadSuccess = downloadPreviewImage(PREVIEW_DOWNLOAD_FILENAME, viewerObj);
    if (downloadSuccess) {
      alert(translate('messages.share_fallback'));
    }
    return downloadSuccess;
  }

  try {
    await navigator.share({
      files: [shareFile],
      title: translate('preview.share_title'),
      text: translate('preview.share_text')
    });
    return true;
  } catch (error) {
    if (error && error.name === 'AbortError') {
      return false;
    }
    console.warn('navigator.share failed', error);
    alert(translate('messages.share_fallback'));
    return false;
  }
}

if (typeof viewer === 'undefined') {
  var viewer = null;
}

function createAxesHelper(scene, size = 1.5) {
  const root = new BABYLON.TransformNode('oryx-axes-root', scene);

  const addVec = (a, b) => new BABYLON.Vector3(a.x + b.x, a.y + b.y, a.z + b.z);

  const colorToCss = color => {
    if (!color) {
      return 'rgba(255, 255, 255, 1)';
    }
    const r = Math.round((color.r || 0) * 255);
    const g = Math.round((color.g || 0) * 255);
    const b = Math.round((color.b || 0) * 255);
    const a = typeof color.a === 'number' ? color.a : 1;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  };

  const helper = {
    root,
    meshes: [],
    isVisible: false,
    setVisible(visible) {
      const state = !!visible;
      this.isVisible = state;
      this.meshes.forEach(mesh => {
        mesh.isVisible = state;
      });
    },
    toggle() {
      this.setVisible(!this.isVisible);
    }
  };

  const registerMesh = mesh => {
    mesh.parent = root;
    mesh.isPickable = false;
    mesh.alwaysSelectAsActiveMesh = false;
    mesh.renderingGroupId = 1;
    mesh.isVisible = false;
    helper.meshes.push(mesh);
    return mesh;
  };

  const createTextBillboard = (id, text, color, sizeFactor = 0.18) => {
    const plane = registerMesh(
      BABYLON.MeshBuilder.CreatePlane(id, { size: sizeFactor }, scene)
    );
    plane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
    const texture = new BABYLON.DynamicTexture(`${id}-texture`, { width: 256, height: 128 }, scene, false);
    texture.hasAlpha = true;
    const ctx = texture.getContext();
    const { width, height } = texture.getSize();
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = 'rgba(6, 6, 10, 0.65)';
    ctx.fillRect(0, 0, width, height);
    ctx.font = 'bold 64px "Inter", "Arial", sans-serif';
    ctx.fillStyle = colorToCss(color);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, width / 2, height / 2);
    texture.update();
    const material = new BABYLON.StandardMaterial(`${id}-material`, scene);
    material.diffuseTexture = texture;
    material.emissiveTexture = texture;
    material.opacityTexture = texture;
    material.disableLighting = true;
    material.backFaceCulling = false;
    plane.material = material;
    return plane;
  };

  const createAxis = (name, direction, color) => {
    const points = [direction.scale(-size), BABYLON.Vector3.Zero(), direction.scale(size)];
    registerMesh(
      BABYLON.MeshBuilder.CreateLines(
        `oryx-axis-${name}`,
        {
          points,
          colors: points.map(() => color)
        },
        scene
      )
    );

    const labelPos = createTextBillboard(`oryx-axis-${name}-label-pos`, `+${name.toUpperCase()}`, color, 0.2);
    labelPos.position = direction.scale(size + 0.2);

    const labelNeg = createTextBillboard(`oryx-axis-${name}-label-neg`, `-${name.toUpperCase()}`, color, 0.2);
    labelNeg.position = direction.scale(-(size + 0.2));

    const tickValues = [];
    for (let value = 0.5; value <= size; value += 0.5) {
      tickValues.push(Number(value.toFixed(2)));
    }

    tickValues.forEach(value => {
      const absoluteTick = createTextBillboard(
        `oryx-axis-${name}-tick-${value}`,
        `+${value}`,
        color,
        0.14
      );
      absoluteTick.position = direction.scale(value);

      const negativeTick = createTextBillboard(
        `oryx-axis-${name}-tick--${value}`,
        `-${value}`,
        color,
        0.14
      );
      negativeTick.position = direction.scale(-value);
    });
  };

  const createGridPlane = (name, axisA, axisB, color, step = 0.5) => {
    const lines = [];
    for (let a = -size; a <= size; a += step) {
      const offset = axisA.scale(a);
      lines.push([
        addVec(axisB.scale(-size), offset),
        addVec(axisB.scale(size), offset)
      ]);
    }
    for (let b = -size; b <= size; b += step) {
      const offset = axisB.scale(b);
      lines.push([
        addVec(axisA.scale(-size), offset),
        addVec(axisA.scale(size), offset)
      ]);
    }
    const grid = BABYLON.MeshBuilder.CreateLineSystem(
      `oryx-grid-${name}`,
      {
        lines,
        colors: lines.map(() => [color, color])
      },
      scene
    );
    registerMesh(grid);
  };

  // Babylon-Standard: X = rechts/links, Z = vorne/hinten (siehe Offsets)
  const gridColor = new BABYLON.Color4(0.75, 0.75, 0.75, 0.35);

  createAxis('x', new BABYLON.Vector3(1, 0, 0), new BABYLON.Color4(1, 0.2, 0.2, 1));
  createAxis('y', new BABYLON.Vector3(0, 1, 0), new BABYLON.Color4(0.2, 1, 0.2, 1));
  createAxis('z', new BABYLON.Vector3(0, 0, 1), new BABYLON.Color4(0.2, 0.6, 1, 1));

  createGridPlane('xz', new BABYLON.Vector3(1, 0, 0), new BABYLON.Vector3(0, 0, 1), gridColor);
  createGridPlane('xy', new BABYLON.Vector3(1, 0, 0), new BABYLON.Vector3(0, 1, 0), gridColor);
  createGridPlane('yz', new BABYLON.Vector3(0, 1, 0), new BABYLON.Vector3(0, 0, 1), gridColor);

  return helper;
}

function createIdleRotationController(scene, camera, { delay = IDLE_ROTATION_DELAY_MS, speed = IDLE_ROTATION_SPEED } = {}) {
  const controller = {
    delay,
    speed,
    observer: null,
    timeoutId: null,
    hasStarted: false,
    isRunning: false,
    isManuallyStopped: false,
    onStateChange: null,
    notifyStateChange() {
      if (typeof this.onStateChange === 'function') {
        this.onStateChange({
          isRunning: this.isRunning,
          hasStarted: this.hasStarted,
          isManuallyStopped: this.isManuallyStopped
        });
      }
    },
    start() {
      if (this.observer) {
        return;
      }
      this.observer = scene.onBeforeRenderObservable.add(() => {
        const deltaSeconds = scene.getEngine().getDeltaTime() / 1000;
        camera.alpha += this.speed * deltaSeconds;
      });
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.hasStarted = true;
      this.isRunning = true;
      this.notifyStateChange();
    },
    stop() {
      if (this.observer) {
        scene.onBeforeRenderObservable.remove(this.observer);
        this.observer = null;
      }
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      const wasRunning = this.isRunning;
      this.isRunning = false;
      if (wasRunning) {
        this.notifyStateChange();
      }
    },
    schedule() {
      if (this.isRunning || this.isManuallyStopped) {
        return;
      }
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = window.setTimeout(() => {
        this.start();
      }, this.delay);
    },
    handleInteraction() {
      if (this.isManuallyStopped) {
        return;
      }
      this.stop();
      this.schedule();
    },
    manualStart() {
      this.isManuallyStopped = false;
      this.stop();
      this.start();
    },
    manualStopRotation() {
      const wasRunning = this.isRunning;
      this.isManuallyStopped = true;
      this.stop();
      if (!wasRunning) {
        this.notifyStateChange();
      }
    }
  };

  return controller;
}

function resetIdleRotationTimer(viewerObj) {
  if (viewerObj?.idleRotation?.handleInteraction) {
    viewerObj.idleRotation.handleInteraction();
  }
}

function getEngravingSelection(selections) {
  if (Array.isArray(selections)) {
    return selections.find(sel => sel?.type === 'engraving');
  }
  if (selections && selections.type === 'engraving') {
    return selections;
  }
  return null;
}

function attachEngravingOverlayToBlade(viewerObj) {
  if (!viewerObj?.engravingOverlay?.anchor) {
    return;
  }
  const bladeRoot = viewerObj.models?.[FOLD_GROUP] || null;
  viewerObj.engravingOverlay.anchor.parent = bladeRoot;
}

function ensureEngravingOverlay(viewerObj) {
  if (!viewerObj || !viewerObj.scene) {
    return null;
  }
  if (viewerObj.engravingOverlay) {
    return viewerObj.engravingOverlay;
  }
  const { scene } = viewerObj;
  const engravingConfig = viewerObj.engravingConfig || getEngravingConfig();
  const anchor = new BABYLON.TransformNode('oryx-engraving-anchor', scene);
  anchor.position = engravingConfig.position.clone();
  anchor.rotation = new BABYLON.Vector3(
    degToRad(engravingConfig.rotationDeg.x),
    degToRad(engravingConfig.rotationDeg.y),
    degToRad(engravingConfig.rotationDeg.z)
  );

  const plane = BABYLON.MeshBuilder.CreatePlane('oryx-engraving-plane', {
    width: engravingConfig.planeWidth,
    height: engravingConfig.planeHeight
  }, scene);
  plane.parent = anchor;
  plane.isPickable = false;
  plane.renderingGroupId = 1;

  const texture = new BABYLON.DynamicTexture(
    'oryx-engraving-texture',
    { width: ENGRAVING_TEXTURE_SIZE.width, height: ENGRAVING_TEXTURE_SIZE.height },
    scene,
    false
  );
  texture.hasAlpha = true;

  const material = new BABYLON.StandardMaterial('oryx-engraving-material', scene);
  material.diffuseTexture = texture;
  material.emissiveTexture = texture;
  material.opacityTexture = texture;
  material.backFaceCulling = true;
  material.forceDepthWrite = true;
  material.needDepthPrePass = true;
  material.specularColor = new BABYLON.Color3(0, 0, 0);
  plane.material = material;
  plane.isVisible = false;

  viewerObj.engravingOverlay = { anchor, plane, texture, material };
  attachEngravingOverlayToBlade(viewerObj);
  return viewerObj.engravingOverlay;
}

function clearEngravingTexture(overlay) {
  if (!overlay?.texture) {
    return;
  }
  const ctx = overlay.texture.getContext();
  const { width, height } = overlay.texture.getSize();
  ctx.clearRect(0, 0, width, height);
  overlay.texture.update();
}

function updateEngravingPreview(viewerObj, selections) {
  if (!viewerObj) {
    return;
  }
  const overlay = ensureEngravingOverlay(viewerObj);
  if (!overlay) {
    return;
  }
  attachEngravingOverlayToBlade(viewerObj);
  const engravingSelection = getEngravingSelection(selections);
  const text = (engravingSelection?.engravingText || '').trim();
  const shouldShow = Boolean(
    engravingSelection && engravingSelection.engravingEnabled !== false && text.length
  );

  if (!shouldShow) {
    overlay.plane.isVisible = false;
    clearEngravingTexture(overlay);
    return;
  }

  const ctx = overlay.texture.getContext();
  const { width, height } = overlay.texture.getSize();
  ctx.clearRect(0, 0, width, height);
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.fillRect(0, 0, width, height);
  ctx.font = `${Math.floor(height * 0.58)}px "Allura", "Great Vibes", serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = '#000000';
  ctx.shadowColor = 'rgba(0, 0, 0, 0)';
  ctx.shadowBlur = 0;
  ctx.fillText(text, width / 2, height / 2);
  overlay.texture.update();
  overlay.plane.isVisible = true;
}

// ===========================================
// Modul 1: Steps‐Daten laden & parsen
// ===========================================
function parseStepsPayload(raw) {
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed?.steps) && parsed.steps.length > 0) {
      return parsed.steps;
    }
  } catch (e) {
    console.error('Steps JSON invalid:', e);
  }
  return null;
}

function getSteps() {
  const dataEl = document.getElementById('oryx-steps-data');
  const container = document.getElementById('configurator-container');

  resolveDefaultBladeModelUrl();

  const scriptSteps = parseStepsPayload(dataEl?.textContent?.trim());
  if (scriptSteps) {
    const bladeStep = scriptSteps.find(step => step?.group === FOLD_GROUP);
    defaultBladeModelUrl = bladeStep?.options?.find(opt => opt?.model_url)?.model_url || defaultBladeModelUrl;
    return scriptSteps;
  }

  const fallbackSteps = parseStepsPayload(container?.dataset?.stepsJson);
  if (fallbackSteps) {
    const bladeStep = fallbackSteps.find(step => step?.group === FOLD_GROUP);
    defaultBladeModelUrl = bladeStep?.options?.find(opt => opt?.model_url)?.model_url || defaultBladeModelUrl;
    return fallbackSteps;
  }

  console.warn('Kein gültiges Steps-JSON gefunden.');
  return [];
}

function preloadCardImages(steps) {
  const urls = new Set();
  steps.forEach(step => {
    if (Array.isArray(step?.options)) {
      step.options.forEach(opt => {
        if (opt?.img_card) {
          urls.add(opt.img_card);
        }
      });
    }
  });

  urls.forEach(url => {
    const img = new Image();
    img.src = url;
  });
}

// ===========================================
// Modul 2: Shopify‐Formular Properties aktualisieren
// ===========================================
function updateShopifyProps(currentSelections) {
  const summary = buildSelectionSummary(currentSelections);
  const propContainer = document.getElementById('oryx-props');
  if (!propContainer) {
    console.warn('Kein #oryx-props Container gefunden.');
    return summary;
  }
  propContainer.innerHTML = '';
  const blockedGroups = new Set([PREVIEW_STEP_NAME, 'Preis']);
  currentSelections.forEach(sel => {
    if (!sel?.group) {
      return;
    }
    if (blockedGroups.has(sel.group)) {
      return;
    }
    if (typeof sel.value !== 'undefined') {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${sel.group}]`;
      input.value = sel.value;
      propContainer.appendChild(input);
    }

    if (sel.type === 'engraving') {
      const engravingInput = document.createElement('input');
      engravingInput.type = 'hidden';
      engravingInput.name = `properties[${sel.group} Text]`;
      engravingInput.value = sel.engravingText || '';
      propContainer.appendChild(engravingInput);
    }
  });
  return summary;
}

function smoothCenterScroll(container, element) {
  if (!container || !element) {
    return;
  }
  const containerWidth = container.clientWidth;
  const center = element.offsetLeft + element.clientWidth / 2;
  const maxScrollLeft = Math.max(container.scrollWidth - containerWidth, 0);
  const targetLeft = Math.min(
    Math.max(center - containerWidth * 0.35, 0),
    maxScrollLeft
  );

  container.scrollTo({
    left: targetLeft,
    behavior: 'smooth'
  });
}

function centerActiveCardOnMobile(track) {
  if (!track || window.innerWidth > 768) {
    return;
  }

  const activeCard = track.querySelector('.oryx-card-option.active');
  if (activeCard) {
    smoothCenterScroll(track, activeCard);
  }
}

// ===========================================
// Modul 2b: Pricing Helper
// ===========================================
function buildSelectionSummary(selections) {
  if (!Array.isArray(selections)) {
    return '';
  }
  return selections
    .map(sel => {
      if (!sel?.group) {
        return '';
      }
      return `${sel.group}: ${sel.value || ''}`.trim();
    })
    .filter(Boolean)
    .join(' | ');
}

function parsePriceValue(value) {
  if (typeof value === 'number') {
    if (value >= 1000) {
      return Math.round(value);
    }
    return Math.round(value * 100);
  }
  if (typeof value === 'string') {
    const normalized = value
      .replace(/[^0-9,.-]/g, '')
      .replace(',', '.');
    const parsed = parseFloat(normalized);
    if (Number.isFinite(parsed)) {
      return Math.round(parsed * 100);
    }
  }
  return 0;
}

function selectionHasOption(selections, groupName, optionValue) {
  if (!Array.isArray(selections)) {
    return false;
  }
  return selections.some(
    selection => selection?.group === groupName && selection?.value === optionValue
  );
}

function getSelectionValue(selections, groupName) {
  if (!Array.isArray(selections)) {
    return null;
  }
  const entry = selections.find(selection => selection?.group === groupName);
  return entry?.value || null;
}

function resolveVariantPricing(pricingConfig, selections) {
  const basePriceCents = Number(pricingConfig?.basePriceCents) || 0;
  const result = {
    variantId: pricingConfig?.baseVariantId,
    priceCents: basePriceCents
  };

  const damastVariantId = pricingConfig?.damastVariantId;
  const damastPriceCents = Number(pricingConfig?.damastPriceCents) || 0;
  const engravedBaseVariantId = pricingConfig?.engravedBaseVariantId;
  const engravedDamastVariantId = pricingConfig?.engravedDamastVariantId;
  const engravedBasePriceCents = Number(pricingConfig?.engravedBasePriceCents) || 0;
  const engravedDamastPriceCents = Number(pricingConfig?.engravedDamastPriceCents) || 0;

  const selectedBlade = getSelectionValue(selections, 'Klingenstahl');
  const hasEngraving = selectionHasOption(selections, 'Gravur', 'Mit Gravur');

  if (hasEngraving && selectedBlade === 'Damast' && engravedDamastVariantId) {
    result.variantId = engravedDamastVariantId;
    result.priceCents = engravedDamastPriceCents || damastPriceCents || basePriceCents;
    return result;
  }

  if (hasEngraving && engravedBaseVariantId) {
    result.variantId = engravedBaseVariantId;
    result.priceCents = engravedBasePriceCents || basePriceCents;
    return result;
  }

  if (selectionHasOption(selections, 'Klingenstahl', 'Damast') && damastVariantId) {
    result.variantId = damastVariantId;
    result.priceCents = damastPriceCents || basePriceCents;
  }

  return result;
}

function getPricingData() {
  const el = document.getElementById('oryx-pricing-data');
  if (!el) {
    console.warn('ORYX Konfigurator: Keine Preisdaten gefunden.');
    return null;
  }
  try {
    const data = JSON.parse(el.textContent || '{}');
    if (Array.isArray(data.surchargeVariants)) {
      data.surchargeVariants = data.surchargeVariants
        .filter(variant => variant && variant.id && Number(variant.price) > 0)
        .map(variant => ({
          id: variant.id,
          price: Number(variant.price)
        }));
    } else {
      data.surchargeVariants = [];
    }
    data.baseVariantId = data.baseVariantId || null;
    data.damastVariantId = data.damastVariantId || null;
    data.engravedBaseVariantId = data.engravedBaseVariantId || null;
    data.engravedDamastVariantId = data.engravedDamastVariantId || null;
    data.basePriceCents = Number(data.basePriceCents) || 0;
    data.damastPriceCents = Number(data.damastPriceCents) || 0;
    data.engravedBasePriceCents = Number(data.engravedBasePriceCents) || 0;
    data.engravedDamastPriceCents = Number(data.engravedDamastPriceCents) || 0;
    return data;
  } catch (error) {
    console.error('ORYX Konfigurator: Konnte Preisdaten nicht parsen.', error);
    return null;
  }
}

function createMoneyFormatter(currency, locale) {
  try {
    const formatter = new Intl.NumberFormat(locale || 'de-DE', {
      style: 'currency',
      currency: currency || 'EUR'
    });
    return cents => formatter.format((cents || 0) / 100);
  } catch (error) {
    console.warn('ORYX Konfigurator: Intl.NumberFormat Fehler, verwende Fallback.', error);
    return cents => `${((cents || 0) / 100).toFixed(2)} ${currency || '€'}`;
  }
}

function updatePricePropertyDisplay(formattedValue, rawCents) {
  const input = document.getElementById('oryx-price-property');
  if (!input) {
    return;
  }
  input.value = formattedValue || '';
  if (typeof rawCents === 'number') {
    input.setAttribute('data-total-cents', String(rawCents));
  }
}

function collectLineItemProperties(form) {
  if (!form) {
    return {};
  }
  const props = {};
  const inputs = form.querySelectorAll('input[name^="properties["]');
  inputs.forEach(input => {
    const match = input.name.match(/^properties\[(.+)\]$/);
    if (match) {
      props[match[1]] = input.value;
    }
  });
  return props;
}

function buildSurchargeLineItems(totalSurchargeCents, variants, summary) {
  if (!totalSurchargeCents || !Array.isArray(variants) || variants.length === 0) {
    return [];
  }
  const normalized = variants
    .filter(variant => variant.price > 0)
    .sort((a, b) => b.price - a.price);

  let remaining = totalSurchargeCents;
  const items = [];
  normalized.forEach(variant => {
    if (remaining <= 0) {
      return;
    }
    const count = Math.floor(remaining / variant.price);
    if (!count) {
      return;
    }
    items.push({
      id: variant.id,
      quantity: count,
      properties: {
        'Hinweis': 'ORYX Konfigurator Aufpreis',
        'Konfiguration': summary || buildSelectionSummary(pricingState.selections)
      }
    });
    remaining -= count * variant.price;
  });

  if (remaining > 0) {
    console.warn('ORYX Konfigurator: Aufpreis konnte nicht exakt dargestellt werden.', {
      remaining,
      total: totalSurchargeCents
    });
    return [];
  }

  return items;
}

function notifySurchargeFallback(message, meta = {}) {
  console.warn(`ORYX Konfigurator: ${message} Aufpreis wird ignoriert.`, meta);
  if (surchargeVariantWarningShown) {
    return;
  }
  surchargeVariantWarningShown = true;
  if (typeof window !== 'undefined' && typeof window.alert === 'function') {
    window.alert(translate('messages.surcharge_fallback'));
  }
}

function setFormBusy(form, isBusy) {
  const submitBtn = form?.querySelector('.oryx-configurator-submit')
    || document.querySelector('.oryx-configurator-submit');
  if (submitBtn) {
    submitBtn.disabled = !!isBusy;
    submitBtn.classList.toggle('is-loading', !!isBusy);
  }
}

function selectionHasValue(selection) {
  if (!selection) {
    return false;
  }
  const value = selection.value;
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  return typeof value !== 'undefined' && value !== null;
}

function requiresEngravingText(step, selection) {
  return step?.type === 'engraving' && selection?.engravingEnabled !== false;
}

function validateConfiguratorSelections(steps, selections) {
  if (!Array.isArray(steps) || !steps.length) {
    return { isValid: true };
  }
  const selectionByGroup = new Map();
  if (Array.isArray(selections)) {
    selections.forEach(sel => {
      if (sel?.group && !selectionByGroup.has(sel.group)) {
        selectionByGroup.set(sel.group, sel);
      }
    });
  }
  for (let i = 0; i < steps.length; i++) {
    const step = steps[i];
    if (!step?.group) {
      continue;
    }
    const selection = selectionByGroup.get(step.group);
    if (!selectionHasValue(selection)) {
      return { isValid: false, step, stepIndex: i };
    }
    if (requiresEngravingText(step, selection)) {
      const text = (selection.engravingText || '').trim();
      if (text.length === 0) {
        return { isValid: false, step, stepIndex: i };
      }
    }
  }
  return { isValid: true };
}

function clearMissingStepIndicators() {
  document.querySelectorAll('.oryx-step-missing').forEach(el =>
    el.classList.remove('oryx-step-missing')
  );
  document.querySelectorAll('.oryx-step-field-missing').forEach(el =>
    el.classList.remove('oryx-step-field-missing')
  );
}

function highlightMissingStep(stepIndex) {
  const stepBar = document.querySelectorAll('.oryx-step');
  const stepFields = document.querySelectorAll('.oryx-step-field');
  const targetStep = stepBar[stepIndex];
  const targetField = stepFields[stepIndex];
  if (targetStep) {
    targetStep.classList.add('oryx-step-missing');
    targetStep.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
  if (targetField) {
    targetField.classList.add('oryx-step-field-missing');
    targetField.scrollIntoView?.({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }
}

function getCartComponent() {
  return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
}

function canRenderCartSections(sectionsPayload, sectionsToRender) {
  if (!sectionsPayload || !Array.isArray(sectionsToRender) || !sectionsToRender.length) {
    return false;
  }
  const parser = new DOMParser();
  return sectionsToRender.every(section => {
    const sectionId = section.section || section.id;
    const html = sectionsPayload[sectionId];
    const selector = section.selector || '.shopify-section';
    if (!html || !selector) {
      return false;
    }
    const parsed = parser.parseFromString(html, 'text/html');
    return Boolean(parsed.querySelector(selector));
  });
}

async function submitConfiguratorForm(form, pricingConfig) {
  if (!form) {
    return;
  }
  const variantInput = form.querySelector('#oryx-variant-id');
  const steps = getSteps();
  const selections = Array.isArray(pricingState.selections) ? pricingState.selections : [];
  const activePricing = resolveVariantPricing(pricingConfig, selections);
  const variantId = activePricing.variantId || variantInput?.value || pricingConfig?.baseVariantId;
  if (variantInput && activePricing.variantId) {
    variantInput.value = activePricing.variantId;
  }
  if (!variantId) {
    console.error('ORYX Konfigurator: Keine Basis-Variante gefunden.');
    form.submit();
    return;
  }
  clearMissingStepIndicators();
  const validationResult = validateConfiguratorSelections(steps, selections);
  if (!validationResult.isValid) {
    highlightMissingStep(validationResult.stepIndex);
    const missingName = translateGroupName(validationResult.step?.group) || translate('messages.unknown_step');
    const missingTemplate = translate('messages.missing_step');
    alert(missingTemplate.replace('{{ step }}', missingName));
    return;
  }

  const quantityInput = form.querySelector('input[name="quantity"]');
  const quantity = Math.max(1, Number(quantityInput?.value) || 1);
  const properties = collectLineItemProperties(form);

  const items = [
    {
      id: Number(variantId) || variantId,
      quantity,
      properties
    }
  ];

  const totalSurchargeCents = 0;
  if (totalSurchargeCents > 0) {
    const configuredVariants = pricingConfig?.surchargeVariants || [];
    if (!configuredVariants.length) {
      notifySurchargeFallback('Keine Aufpreis-Varianten konfiguriert.', { totalSurchargeCents });
    } else {
      const surchargeItems = buildSurchargeLineItems(
        totalSurchargeCents,
        configuredVariants,
        pricingState.summary
      );
      if (surchargeItems.length) {
        items.push(...surchargeItems);
      } else {
        notifySurchargeFallback('Aufpreis konnte nicht über Varianten abgebildet werden.', { totalSurchargeCents });
      }
    }
  }

  const previewKeyInput = form.querySelector('input[name="preview_key"]');
  const previewKey = previewKeyInput?.value || pricingConfig?.previewKey;
  const url = previewKey ? `/cart/add.js?preview_key=${encodeURIComponent(previewKey)}` : '/cart/add.js';
  const cartComponent = getCartComponent();
  const cartSectionsConfig = cartComponent?.getSectionsToRender?.() || [];
  const cartSections = cartSectionsConfig.map(section => section.section || section.id);

  setFormBusy(form, true);
  try {
    const body = {
      items
    };
    if (cartSections.length) {
      body.sections = cartSections;
      body.sections_url = window.location.pathname;
      cartComponent?.setActiveElement?.(document.activeElement);
    }
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(message || translate('messages.unknown_cart_error'));
    }

    const data = await response.json();
    document.dispatchEvent(new CustomEvent('oryx:cartAddSuccess', { detail: data }));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oryx-configurator', cartData: data });
    }

    const hasRenderableCartSections = canRenderCartSections(data?.sections, cartSectionsConfig);
    const hasSectionsPayload = Boolean(data?.sections);
    const canRenderCartComponent = (
      cartComponent
      && typeof cartComponent.renderContents === 'function'
      && cartSections.length > 0
      && hasRenderableCartSections
      && hasSectionsPayload
    );

    if (canRenderCartComponent) {
      cartComponent.classList?.remove('is-empty');
      cartComponent.renderContents(data);
    } else if (cartComponent && typeof cartComponent.renderContents === 'function' && hasSectionsPayload) {
      console.warn('ORYX Konfigurator: Warenkorb-Overlay wird ohne Section-Update geöffnet.');
      cartComponent.classList?.remove('is-empty');
      cartComponent.renderContents(data);
    } else if (cartComponent && typeof cartComponent.open === 'function') {
      console.warn('ORYX Konfigurator: Warenkorb-Overlay ohne neue Sections geöffnet.');
      cartComponent.classList?.remove('is-empty');
      cartComponent.open();
    } else {
      console.warn('ORYX Konfigurator: Warenkorb-Overlay kann nicht aktualisiert werden, Redirect zum Warenkorb.');
      window.location.href = '/cart';
    }
  } catch (error) {
    console.error('ORYX Konfigurator: Fehler beim Warenkorb-Request', error);
    alert(error?.message || translate('messages.add_to_cart_failed'));
  } finally {
    setFormBusy(form, false);
  }
}

function setupConfiguratorForm(pricingConfig) {
  const form = document.getElementById('oryx-configurator-form');
  if (!form) {
    return;
  }
  if (!pricingConfig) {
    console.warn('ORYX Konfigurator: Es liegen keine Preisdaten vor – Standardformular wird verwendet.');
    return;
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    submitConfiguratorForm(form, pricingConfig);
  });
}

// ===========================================
// Modul 3: Babylon.js Viewer initialisieren
// ===========================================
function initBabylonViewer() {
  const canvas = document.getElementById('threngine_canvas');
  if (!canvas) {
    console.warn('Kein <canvas id="threngine_canvas"> gefunden.');
    return null;
  }

  const engine = new BABYLON.Engine(canvas, true, {
    preserveDrawingBuffer: true,
    stencil: true,
    alpha: true
  });
  const scene = new BABYLON.Scene(engine);
  scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);

  const environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(
    'https://assets.babylonjs.com/environments/environmentSpecular.env',
    scene
  );
  scene.environmentTexture = environmentTexture;
  scene.environmentIntensity = 1.05;
  const skybox = scene.createDefaultSkybox(environmentTexture, true, 80, 0.35, false, true);
  if (skybox) {
    skybox.isPickable = false;
    skybox.infiniteDistance = true;
  }

  // 1) Desktop vs. Mobil ermitteln
  const isMobile = window.innerWidth <= 768;
  const radiusDesktop = 8;   // Zoom‐Abstand für Desktop
  const radiusMobile  = 14;  // Zoom‐Abstand für Mobil (weiterer Startabstand)
  const initialRadius = isMobile ? radiusMobile : radiusDesktop;
  const engravingConfig = getEngravingConfig();

  // 2) Kamerawinkel in Grad definieren und in Radiant umrechnen
  const alphaRad = degToRad(180);
  const betaRad  = degToRad(90);

  const camera = new BABYLON.ArcRotateCamera(
    'camera',
    alphaRad,
    betaRad,
    initialRadius,
    new BABYLON.Vector3(0, 0.5, 0),
    scene
  );
  camera.attachControl(canvas, false);

  const initialCameraState = {
    alpha: camera.alpha,
    beta: camera.beta,
    radius: camera.radius,
    target: camera.target.clone()
  };

  const axesHelper = createAxesHelper(scene, 1.5);
  const idleRotation = createIdleRotationController(scene, camera);
  if (idleRotation) {
    idleRotation.schedule();
  }

  // 3) Zoom‐Limits
  camera.lowerRadiusLimit = 0.5;
  camera.upperRadiusLimit = isMobile ? 45.0 : 15.0;
  camera.wheelPrecision   = 100;
  camera.minZ             = 0.01;

  // 3b) Touch-Pinch spürbar entschärfen (unterschiedliche Werte für Mobil/Desktop)
  const pinchDeltaMobile = 0.007;
  const pinchDeltaDesktop = 0.004;
  camera.pinchDeltaPercentage = isMobile ? pinchDeltaMobile : pinchDeltaDesktop;
  camera.pinchPrecision = isMobile ? 180 : 120;



  // Hauptlicht-Setup: stärkeres Key-Light und ein 360°-Ring aus Fülllichtern
  const hemiLight = new BABYLON.DirectionalLight(
    'hemiLight',
    new BABYLON.Vector3(0, -1, 0),
    scene
  );
  hemiLight.position = new BABYLON.Vector3(-70, 0, 0);
  hemiLight.intensity = 0.85;
  hemiLight.shadowEnabled = false;

  const dirLight = new BABYLON.DirectionalLight(
    'dirLight',
    new BABYLON.Vector3(0, 0, -1),
    scene
  );
  dirLight.position = new BABYLON.Vector3(0, 0, 100);
  dirLight.intensity = 0.75;
  dirLight.shadowEnabled = false;

  const fillLight = new BABYLON.DirectionalLight(
    'fillLight',
    new BABYLON.Vector3(0, 0, 1),
    scene
  );
  fillLight.position = new BABYLON.Vector3(0, 10, -20);
  fillLight.intensity = 0.65;
  fillLight.shadowEnabled = false;

  const cameraLight = new BABYLON.DirectionalLight(
    'cameraLight',
    new BABYLON.Vector3(0, 0, -1),
    scene
  );
  cameraLight.intensity = 1.15;
  cameraLight.shadowEnabled = false;

  const updateCameraLight = () => {
    const direction = camera.target.subtract(camera.position).normalize();
    cameraLight.direction = direction;
    cameraLight.position.copyFrom(camera.position);
  };
  updateCameraLight();
  camera.onViewMatrixChangedObservable.add(updateCameraLight);

  const ambient = new BABYLON.HemisphericLight('ambient', new BABYLON.Vector3(0, 1, 0), scene);
  ambient.intensity = 0.9;

  const ringLightConfigs = Array.from({ length: 4 }, (_, i) => {
    const angle = (Math.PI * 2 * i) / 4;
    const x = Math.cos(angle);
    const z = Math.sin(angle);
    return {
      direction: new BABYLON.Vector3(-x, -0.25, -z),
      position: new BABYLON.Vector3(x * 70, 40, z * 70)
    };
  });

  ringLightConfigs.forEach((cfg, index) => {
    const rimLight = new BABYLON.DirectionalLight(`oryx-rim-${index}`, cfg.direction, scene);
    rimLight.position = cfg.position;
    rimLight.intensity = 0.7;
    rimLight.shadowEnabled = false;
  });

  const glow = new BABYLON.GlowLayer('glow', scene);
  glow.intensity = 0.2;


  const models = {};
  const runtime = {};
  const rootTransform = new BABYLON.TransformNode('oryx-root', scene);
  if (axesHelper?.root) {
    axesHelper.root.parent = rootTransform;
  }

  const arGround = BABYLON.MeshBuilder.CreateGround('oryx-ar-ground', {
    width: 18,
    height: 18
  }, scene);
  arGround.isVisible = false;
  arGround.isPickable = true;

  const arCursor = BABYLON.MeshBuilder.CreateTorus('oryx-ar-cursor', {
    thickness: 0.02,
    diameter: 0.35
  }, scene);
  arCursor.isVisible = false;
  arCursor.isPickable = false;
  arCursor.rotation.x = Math.PI / 2;
  arCursor.renderingGroupId = 2;
  const arCursorMat = new BABYLON.StandardMaterial('oryx-ar-cursor-material', scene);
  arCursorMat.emissiveColor = new BABYLON.Color3(0.78, 0.56, 0.31);
  arCursorMat.alpha = 0.9;
  arCursor.material = arCursorMat;

  const pipeline = new BABYLON.DefaultRenderingPipeline('oryx-pipeline', true, scene, [camera]);
  pipeline.samples = 4;
  pipeline.bloomEnabled = true;
  pipeline.bloomThreshold = 0.8;
  pipeline.bloomWeight = 0.08;
  if (pipeline.imageProcessing) {
    pipeline.imageProcessing.toneMappingEnabled = true;
    pipeline.imageProcessing.toneMappingType = BABYLON.ImageProcessingConfiguration.TONEMAPPING_ACES;
    pipeline.imageProcessing.exposure = 1.05;
  }

  engine.runRenderLoop(() => {
    scene.render();
  });

  window.addEventListener('resize', () => {
    engine.resize();
  });

  if (idleRotation && canvas) {
    const resetIdle = () => idleRotation.handleInteraction();
    ['pointerdown', 'pointermove', 'touchstart', 'wheel'].forEach(evt =>
      canvas.addEventListener(evt, resetIdle, { passive: true })
    );
    ['pointerdown', 'touchstart', 'wheel'].forEach(evt =>
      document.addEventListener(evt, resetIdle, { passive: true })
    );
    window.addEventListener('keydown', resetIdle);
  }

  return {
    scene,
    engine,
    models,
    camera,
    initialCameraState,
    runtime,
    axesHelper,
    idleRotation,
    rootTransform,
    arGround,
    arCursor,
    engravingConfig,
    environmentTexture,
    skybox,
    arEnvironmentBackup: null,
    xrExperience: null
  };
}



// ===========================================
// Zusatzmodule: Preview-Controls & Animationen
// ===========================================
function normalizeAngleToNearest(current, target) {
  if (typeof current !== 'number' || typeof target !== 'number') {
    return target;
  }
  const fullTurn = Math.PI * 2;
  const turnOffset = Math.round((current - target) / fullTurn);
  return target + turnOffset * fullTurn;
}

function animateCameraToInitial(viewerObj) {
  if (!viewerObj || !viewerObj.camera || !viewerObj.initialCameraState) {
    return;
  }
  resetIdleRotationTimer(viewerObj);
  const { camera, scene, initialCameraState } = viewerObj;
  const normalizedAlpha = normalizeAngleToNearest(camera.alpha, initialCameraState.alpha);
  const easing = new BABYLON.CubicEase();
  easing.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

  BABYLON.Animation.CreateAndStartAnimation(
    'oryx-cam-alpha',
    camera,
    'alpha',
    60,
    40,
    camera.alpha,
    normalizedAlpha,
    0,
    easing
  );
  BABYLON.Animation.CreateAndStartAnimation(
    'oryx-cam-beta',
    camera,
    'beta',
    60,
    40,
    camera.beta,
    initialCameraState.beta,
    0,
    easing
  );
  BABYLON.Animation.CreateAndStartAnimation(
    'oryx-cam-radius',
    camera,
    'radius',
    60,
    40,
    camera.radius,
    initialCameraState.radius,
    0,
    easing
  );

  const targetAnim = new BABYLON.Animation(
    'oryx-cam-target',
    'target',
    60,
    BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
    BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
  );
  targetAnim.setKeys([
    { frame: 0, value: camera.target.clone() },
    { frame: 40, value: initialCameraState.target.clone() }
  ]);
  targetAnim.setEasingFunction(easing);
  scene.beginDirectAnimation(camera, [targetAnim], 0, 40, false, 1);
}

function animateCameraToConfig(viewerObj, config = {}, frames = 45) {
  if (!viewerObj || !viewerObj.camera || !viewerObj.scene || !config) {
    return;
  }
  resetIdleRotationTimer(viewerObj);
  const { camera, scene } = viewerObj;
  const easing = new BABYLON.CubicEase();
  easing.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

  if (typeof config.alpha === 'number') {
    const normalizedAlpha = normalizeAngleToNearest(camera.alpha, config.alpha);
    BABYLON.Animation.CreateAndStartAnimation(
      'oryx-cam-focus-alpha',
      camera,
      'alpha',
      60,
      frames,
      camera.alpha,
      normalizedAlpha,
      0,
      easing
    );
  }
  if (typeof config.beta === 'number') {
    BABYLON.Animation.CreateAndStartAnimation(
      'oryx-cam-focus-beta',
      camera,
      'beta',
      60,
      frames,
      camera.beta,
      config.beta,
      0,
      easing
    );
  }
  if (typeof config.radius === 'number') {
    BABYLON.Animation.CreateAndStartAnimation(
      'oryx-cam-focus-radius',
      camera,
      'radius',
      60,
      frames,
      camera.radius,
      config.radius,
      0,
      easing
    );
  }
  if (config.target instanceof BABYLON.Vector3) {
    const targetAnim = new BABYLON.Animation(
      'oryx-cam-focus-target',
      'target',
      60,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
    );
    targetAnim.setKeys([
      { frame: 0, value: camera.target.clone() },
      { frame: frames, value: config.target.clone() }
    ]);
    targetAnim.setEasingFunction(easing);
    scene.beginDirectAnimation(camera, [targetAnim], 0, frames, false, 1);
  }
}

function getModelFocusConfig(viewerObj, groupName) {
  const root = viewerObj?.models?.[groupName];
  const camera = viewerObj?.camera;

  if (!root || !camera || typeof root.getHierarchyBoundingVectors !== 'function') {
    return null;
  }

  const bounds = root.getHierarchyBoundingVectors(true);
  if (!bounds?.min || !bounds?.max) {
    return null;
  }

  const size = bounds.max.subtract(bounds.min);
  const maxDim = Math.max(size.x, size.y, size.z);
  const center = bounds.min.add(size.scale(0.5));
  const baseRadius = Math.max(camera.radius * 0.3, 1.2);
  const radius = maxDim > 0 ? Math.max(maxDim * 1.8, baseRadius) : camera.radius;

  return {
    radius,
    target: center
  };
}

function getEngravingFocusConfig(viewerObj) {
  const overlay = ensureEngravingOverlay(viewerObj);
  const camera = viewerObj?.camera;

  if (!overlay || !camera) {
    return null;
  }

  attachEngravingOverlayToBlade(viewerObj);

  const minRadius = 0.35;
  const maxRadius = Math.max(minRadius, Math.min(camera.radius * 0.9, 3));

  let target = overlay.anchor.getAbsolutePosition?.() || overlay.anchor.position.clone();
  let radius = Math.min(Math.max(camera.radius * 0.6, minRadius), maxRadius);

  if (overlay.plane?.getHierarchyBoundingVectors) {
    const bounds = overlay.plane.getHierarchyBoundingVectors(true);
    if (bounds?.min && bounds?.max) {
      const size = bounds.max.subtract(bounds.min);
      const center = bounds.min.add(size.scale(0.5));
      const maxDim = Math.max(size.x, size.y, size.z);
      const radiusFromPlane = Math.max(maxDim * 2.1, minRadius);

      target = center;
      radius = Math.min(Math.max(radiusFromPlane, minRadius), maxRadius);
    }
  }

  return { radius, target };
}

function focusCameraForGroup(viewerObj, groupName) {
  if (!viewerObj) {
    return false;
  }

  if (groupName === 'Gravur') {
    const engravingFocus = getEngravingFocusConfig(viewerObj);
    if (engravingFocus) {
      animateCameraToConfig(viewerObj, engravingFocus, 50);
      return true;
    }

    const fallbackRadius = Math.max(0.35, Math.min(viewerObj.camera.radius * 0.75, 3));
    const fallbackTarget = viewerObj.engravingConfig?.position || viewerObj.camera.target;
    animateCameraToConfig(viewerObj, { radius: fallbackRadius, target: fallbackTarget }, 50);
    return true;
  }

  if (!groupName || groupName === PREVIEW_STEP_NAME) {
    animateCameraToInitial(viewerObj);
    return true;
  }

  const customFocus = CAMERA_FOCUS_CONFIG[groupName];
  const modelFocus = getModelFocusConfig(viewerObj, groupName);

  if (customFocus) {
    animateCameraToConfig(viewerObj, customFocus);
    return true;
  }
  if (modelFocus) {
    animateCameraToConfig(viewerObj, modelFocus, 45);
    return true;
  }

  // Fallback: Kein spezifischer Fokus vorhanden -> auf initiale Kameraposition gehen
  animateCameraToInitial(viewerObj);
  return true;
}

function setupMobileFullscreenHint() {
  const hint = document.getElementById('oryx-mobile-fullscreen-hint');
  if (!hint) {
    return;
  }

  const acceptBtn = document.getElementById('oryx-mobile-fullscreen-accept');
  const skipBtn = document.getElementById('oryx-mobile-fullscreen-skip');
  const fullscreenBtn = document.getElementById('oryx-fullscreen-btn');
  const mediaQuery = typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 900px)')
    : null;

  const hideHint = () => {
    hint.hidden = true;
    hint.setAttribute('aria-hidden', 'true');
  };

  const tryLockLandscape = () => {
    const orientation = window.screen?.orientation;
    if (orientation && typeof orientation.lock === 'function') {
      orientation.lock('landscape').catch(() => {});
    }
  };

  const showHint = () => {
    const isFullscreen = Boolean(document.fullscreenElement);
    const shouldShow = (isMobileDevice() || mediaQuery?.matches) && !mobileFullscreenDismissed && !isFullscreen;
    if (shouldShow) {
      hint.hidden = false;
      hint.setAttribute('aria-hidden', 'false');
      if (acceptBtn && typeof acceptBtn.focus === 'function') {
        acceptBtn.focus({ preventScroll: true });
      }
      return;
    }
    hideHint();
  };

  const requestFullscreenFromHint = async () => {
    const container = document.getElementById('configurator-container');
    if (!container) {
      return false;
    }
    if (document.fullscreenElement === container) {
      return true;
    }
    if (typeof container.requestFullscreen === 'function') {
      try {
        await container.requestFullscreen();
        return true;
      } catch (error) {
        console.debug('Fullscreen konnte nicht aktiviert werden', error);
      }
    }
    return false;
  };

  const dismissHint = () => {
    mobileFullscreenDismissed = true;
    hideHint();
  };

  if (acceptBtn) {
    acceptBtn.addEventListener('click', async () => {
      const startedFullscreen = await requestFullscreenFromHint();
      if (!startedFullscreen && fullscreenBtn) {
        fullscreenBtn.click();
      } else {
        tryLockLandscape();
      }
      dismissHint();
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener('click', () => {
      dismissHint();
    });
  }

  const onFullscreenChange = () => {
    if (document.fullscreenElement) {
      tryLockLandscape();
    }
    showHint();
  };

  document.addEventListener('fullscreenchange', onFullscreenChange);

  if (mediaQuery) {
    const mediaChangeHandler = () => showHint();
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', mediaChangeHandler);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(mediaChangeHandler);
    }
  }

  window.addEventListener('orientationchange', showHint, { passive: true });
  window.addEventListener('resize', showHint, { passive: true });

  showHint();
}

// ===============================================================
// MODULE AUSTAUSCH: SETUP PREVIEW CONTROLS (in oryx-configurator.js)
// ===============================================================
function setupPreviewControls(viewerObj) {
  const fullscreenBtn = document.getElementById('oryx-fullscreen-btn');
  const resetBtn = document.getElementById('oryx-reset-btn');
  const debugBtn = document.getElementById('oryx-debug-btn');
  const rotationToggleBtn = document.getElementById('oryx-rotation-toggle-btn');
  const arBtn = document.getElementById('oryx-ar-btn');
  
  // AR Modul Initialisierung
  if (arMode?.setupArControl) {
    arMode.setupArControl(viewerObj);
  }

  // Dieser Block sorgt für die Anzeige des AR-Modus
  const bindArCapabilityDebugHandler = () => {
    if (!arBtn || arBtn.dataset.handlerAttached === 'true') return;
    arBtn.dataset.handlerAttached = 'true';

    arBtn.addEventListener('click', async event => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const capability = await detectARCapability();
      console.log('AR Check Result:', capability);

      // FEEDBACK: Welcher Modus wird genutzt?
      if (capability === 'webxr') {
        alert("Starte WebXR AR (Android Chrome)..."); // Feedback 1
        if (typeof window?.OryxAR?.startSession === 'function') {
           await window.OryxAR.startSession();
        }
      } 
      else if (capability === 'ios-native') {
        alert("Starte iOS QuickLook..."); // Feedback 2
        if (typeof window?.OryxAR?.openQuickLook === 'function') {
           window.OryxAR.openQuickLook();
        }
      } 
      else if (capability === 'android-native') {
        alert("Starte Android SceneViewer..."); // Feedback 3
        if (typeof window?.OryxAR?.openSceneViewerIntent === 'function') {
           window.OryxAR.openSceneViewerIntent();
        }
      } 
      else {
        alert(translate('messages.ar_not_supported') + " (Kein Modus erkannt)");
      }
    }, { capture: true }); // Capture Phase nutzen um andere Handler zu übertrumpfen
  };

  bindArCapabilityDebugHandler();

  if (!viewerObj) {
    if (resetBtn) resetBtn.disabled = true;
    if (fullscreenBtn) fullscreenBtn.disabled = true;
    if (debugBtn) debugBtn.disabled = true;
    if (rotationToggleBtn) rotationToggleBtn.disabled = true;
    return;
  }

  const canvas = viewerObj.engine?.getRenderingCanvas();
  const fullscreenTarget = document.getElementById('configurator-container') || canvas;

  if (fullscreenBtn && fullscreenTarget) {
    const fullscreenLabel = fullscreenBtn.querySelector('.oryx-preview-control-label');
    const defaultLabel = fullscreenLabel?.dataset.defaultLabel || fullscreenLabel?.textContent?.trim();
    const exitLabel = fullscreenLabel?.dataset.exitLabel || fullscreenLabel?.textContent?.trim();

    const updateFullscreenState = () => {
      const isActive = document.fullscreenElement === fullscreenTarget;
      fullscreenBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      fullscreenTarget.classList.toggle('oryx-fullscreen-active', isActive);
      document.body.classList.toggle('oryx-fullscreen-open', isActive);
      document.body.classList.toggle('oryx-mobile-fullscreen', isActive && isMobileDevice());

      if (fullscreenLabel && defaultLabel && exitLabel) {
        fullscreenLabel.textContent = isActive ? exitLabel : defaultLabel;
      }
    };

    fullscreenBtn.addEventListener('click', () => {
      const isActive = document.fullscreenElement === fullscreenTarget;
      if (!isActive) {
        fullscreenTarget.requestFullscreen?.();
      } else {
        document.exitFullscreen?.();
      }
    });

    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange']
      .forEach(evt => document.addEventListener(evt, updateFullscreenState));
    updateFullscreenState();
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      animateCameraToInitial(viewerObj);
    });
  }

  if (debugBtn) {
    const updateDebugButtonVisual = isActive => {
      const label = debugBtn.querySelector('.oryx-preview-control-label');
      if (label) {
        label.textContent = isActive
          ? translate('controls.debug_hide')
          : translate('controls.debug_show');
      }
      debugBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    };

    if (viewerObj.axesHelper) {
      debugBtn.disabled = false;
      updateDebugButtonVisual(viewerObj.axesHelper.isVisible);
      debugBtn.addEventListener('click', () => {
        viewerObj.axesHelper.toggle();
        updateDebugButtonVisual(viewerObj.axesHelper.isVisible);
      });
    } else {
      debugBtn.disabled = true;
    }
  }

  if (rotationToggleBtn) {
    const rotationController = viewerObj.idleRotation;
    const label = rotationToggleBtn.querySelector('.oryx-preview-control-label');
    const icon = rotationToggleBtn.querySelector('.oryx-preview-control-icon');
    const updateRotationButton = () => {
      const hasController = Boolean(rotationController);
      const isRunning = !!rotationController?.isRunning;
      rotationToggleBtn.disabled = !hasController;
      rotationToggleBtn.setAttribute('aria-pressed', isRunning ? 'true' : 'false');
      if (label) {
        label.textContent = isRunning
          ? translate('controls.rotation_stop')
          : translate('controls.rotation_start');
      }
      if (icon) {
        icon.textContent = isRunning ? '■' : '▶';
      }
    };

    if (rotationController) {
      rotationToggleBtn.addEventListener('click', () => {
        if (rotationController.isRunning) {
          rotationController.manualStopRotation();
        } else {
          rotationController.manualStart();
        }
        updateRotationButton();
      });
      rotationController.onStateChange = updateRotationButton;
      if (typeof rotationController.notifyStateChange === 'function') {
        rotationController.notifyStateChange();
      } else {
        updateRotationButton();
      }
    } else {
      updateRotationButton();
    }
  }
}

document.addEventListener('oryx:modelLoaded', event => {
  if (event.detail?.group === FOLD_GROUP && viewer) {
    attachEngravingOverlayToBlade(viewer);
    updateEngravingPreview(viewer, pricingState.selections);
  }
});



// ===========================================
// Modul 4: showPart – GLB laden und sauber anzeigen
// ===========================================
function ensurePbrEnvironment(material, scene) {
  if (!(material instanceof BABYLON.PBRMaterial)) return;
  if (scene.environmentTexture && !material.environmentTexture) {
    material.environmentTexture = scene.environmentTexture;
  }
  if (typeof material.environmentIntensity !== 'number') {
    material.environmentIntensity = scene.environmentIntensity ?? 1;
  }
  if (typeof material.roughness !== 'number') {
    material.roughness = 0.65;
  }
}

function showPart(viewerObj, group, url, isFallback = false) {
  if (!viewerObj) {
    console.warn('viewerObj ist null – showPart übersprungen.');
    return;
  }
  const { scene, engine, models } = viewerObj;

  if (models[group]?.metadata?.currentUrl === url) {
    return;
  }

  const existingRoot = models[group];
  if (!url) {
    const fallbackUrl = group === FOLD_GROUP ? resolveDefaultBladeModelUrl() : null;
    if (fallbackUrl && !isFallback) {
      showPart(viewerObj, group, fallbackUrl, true);
      return;
    }
    engine.hideLoadingUI?.();
    return;
  }

  // 2) Zeige Lade‐UI
  engine.displayLoadingUI?.();

  // 3) URL in rootUrl + filename zerlegen
  let rootUrl = '';
  let filename = url;
  try {
    const parts = url.split('/');
    filename = parts.pop();
    rootUrl = parts.join('/') + '/';
  } catch {
    rootUrl = '';
    filename = url;
  }

  // 4) ImportMesh statt Append → Nur die neuen Meshes werden geliefert
  BABYLON.SceneLoader.ImportMesh(
    '',
    rootUrl,
    filename,
    scene,
    function (meshes) {
      // onSuccess
      engine.hideLoadingUI?.();

      // a) Neues TransformNode als Wurzel für alle Sub‐Meshes dieser Gruppe
      const root = new BABYLON.TransformNode(group + '_root', scene);
      if (viewerObj.rootTransform) {
        root.parent = viewerObj.rootTransform;
      }

      meshes.forEach(mesh => {
        mesh.setParent(root);
        mesh.receiveShadows = true;
        mesh.castShadow = true;

        // Falls BasicMaterial, in PBRMaterial konvertieren
        if (mesh.material && !(mesh.material instanceof BABYLON.PBRMaterial)) {
          const oldMat = mesh.material;
          const pbr = new BABYLON.PBRMaterial(oldMat.name + '_pbr', scene);
          if (oldMat.diffuseTexture)  pbr.albedoTexture   = oldMat.diffuseTexture;
          if (oldMat.emissiveTexture) pbr.emissiveTexture = oldMat.emissiveTexture;
          if (oldMat.bumpTexture)     pbr.bumpTexture     = oldMat.bumpTexture;
          if (oldMat.specularTexture) pbr.metallicTexture = oldMat.specularTexture;
          ensurePbrEnvironment(pbr, scene);
          pbr.roughness = 0.65;
          pbr.metallic  = 0.25;
          mesh.material = pbr;
        }

        ensurePbrEnvironment(mesh.material, scene);

        if (['Klingenstahl','Feder','Ring','Schraube','Niete'].includes(group)
            && mesh.material instanceof BABYLON.PBRMaterial) {
          mesh.material.roughness = 0.4;
          mesh.material.metallic  = 1.0;
        }

        if (group === 'Griffmaterial' && mesh.material instanceof BABYLON.PBRMaterial) {
          mesh.material.roughness = 0.5;
          mesh.material.metallic  = 0.2;
        }
      });

      // 5) Bounding‐Box des gesamten root‐Nodes berechnen
      const bv = root.getHierarchyBoundingVectors(true);
      const sizeVec = bv.max.subtract(bv.min);
      const maxDim = Math.max(sizeVec.x, sizeVec.y, sizeVec.z);
      let scaleFactor = maxDim > 0 ? 6.0 / maxDim : 1;

      // 6) Gruppenspezifische Offsets + Extraskalierung (X = rechts/links, Y = oben/unten, Z = vorne/hinten)
      let offsetX = 0,
        offsetY = 0,
        offsetZ = 0;
      if (group === 'Klingenstahl') {
        offsetX = 0.105;
        offsetZ = 2.46;
        offsetY = 0.6;
      } else if (group === 'Griffmaterial') {
        offsetX = 0;
        offsetZ = -2.52;
      } else if (group === 'Feder') {
        offsetX = 0.005; 
        offsetY = 0.73;  
        offsetZ = -1.99; 
        scaleFactor *= 0.79;
      } else if (group === 'Ring') {
        offsetX = 0.05;
        offsetY = 1.65;
        offsetZ = 0.23;
        scaleFactor *= 0.2;
      } else if (group === 'Schraube') {
        offsetX = 0.035;
        offsetY = 0.19;
        offsetZ = 0.04;
        scaleFactor *= 0.112;
      } else if (group === 'Niete') {
        offsetX = 0;
        offsetY = 0.33;
        offsetZ = -2.45;
        scaleFactor *= 0.12;
      } else if (group === 'Gravur') {
        const engravingConfig = getEngravingConfig();
        offsetX = engravingConfig.position.x;
        offsetY = engravingConfig.position.y;
        offsetZ = engravingConfig.position.z;
      }

      // 7) Skalierung anwenden
      root.scaling = new BABYLON.Vector3(scaleFactor, scaleFactor, scaleFactor);

      // 8) Vergrosserte Bounding‐Box neu berechnen und zentrieren + Verschieben
      const scaledMin = bv.min.scale(scaleFactor);
      const scaledMax = bv.max.scale(scaleFactor);
      const scaledCenter = scaledMin.add(scaledMax).scale(0.5);
      const scaledSizeVec = scaledMax.subtract(scaledMin);
      const scaledMaxDimension = Math.max(scaledSizeVec.x, scaledSizeVec.y, scaledSizeVec.z);
      root.position = new BABYLON.Vector3(
        -scaledCenter.x + offsetX,
        -scaledCenter.y + offsetY,
        -scaledCenter.z + offsetZ
      );

      if (group === FOLD_GROUP) {
        const pivotWorld = getBladePivotWorld();
        const pivotLocal = pivotWorld.subtract(root.position).divide(root.scaling);
        const worldPosBeforePivot = root.getAbsolutePosition().clone();
        root.setPivotPoint(pivotLocal);
        root.setAbsolutePosition(worldPosBeforePivot);
      }

      // 9) TransformNode im models‐Objekt speichern
      root.metadata = Object.assign({}, root.metadata, {
        currentUrl: url,
        scaleFactor,
        scaledMaxDimension
      });
      viewerObj.arOriginalScaling = null;
      models[group] = root;

      if (existingRoot && existingRoot !== root) {
        existingRoot.getChildren().forEach(child => child.dispose(true, true));
        existingRoot.dispose(true, true);
      }

      document.dispatchEvent(new CustomEvent('oryx:modelLoaded', {
        detail: { group, root }
      }));

    },
    function (event) {
      // onProgress
      if (engine.loadingScreen?.displayLoadingUISync && event.lengthComputable) {
        engine.loadingScreen.displayLoadingUISync(event.loaded / event.total);
      }
    },
    function (scene, exception) {
      // onError
      console.error('Error loading GLB für Gruppe', group, exception);
      engine.hideLoadingUI?.();

      if (
        group === FOLD_GROUP &&
        !isFallback &&
        resolveDefaultBladeModelUrl() &&
        url !== defaultBladeModelUrl
      ) {
        console.warn('Falle auf Standard-Klingenmodell zurück.');
        showPart(viewerObj, group, defaultBladeModelUrl, true);
        return;
      }

      if (existingRoot && !models[group]) {
        models[group] = existingRoot;
      }
    }
  );
}



// ===========================================
// Modul 5: UI – Steps, Optionen, Preis, Stepper
// ===========================================
function initUI(steps, options = {}) {
  const stepFields   = document.querySelectorAll('.oryx-step-field');
  const stepBar      = document.querySelectorAll('.oryx-step');
  const priceDisplay = document.getElementById('oryx-price-display');

  if (stepFields.length === 0 || stepBar.length === 0) {
    console.warn('initUI: Keine .oryx-step- oder .oryx-step-field-Elemente gefunden.');
    return;
  }

  const {
    onSelectionChange,
    onPriceChange,
    basePriceCents = 0,
    pricingConfig = null,
    formatMoney = cents => `${((cents || 0) / 100).toFixed(2)} €`
  } = options;

  let currentStepIdx = 0;
  let currentSelections = steps.map(step => {
    const firstOption = Array.isArray(step.options) && step.options.length > 0
      ? step.options[0]
      : {};
    const selection = {
      group: step.group,
      type: step.type,
      ...firstOption
    };
    if (step.type === 'engraving') {
      selection.engravingText = '';
    }
    return selection;
  });
  const stepRenderCache = new Map();

  function applyCameraFocus(stepIdx) {
    const stepConfig = steps[stepIdx];
    const shouldSkipFocus =
      !viewer ||
      typeof stepIdx !== 'number' ||
      stepIdx < 0 ||
      stepIdx >= steps.length ||
      !stepConfig;

    if (shouldSkipFocus) {
      return;
    }

    focusCameraForGroup(viewer, stepConfig.group);
  }

  function preloadUpcomingModels(stepIdx) {
    const maxIdx = Math.min(steps.length - 1, stepIdx + 1);
    for (let i = stepIdx; i <= maxIdx; i++) {
      const opts = Array.isArray(steps[i]?.options) ? steps[i].options : [];
      opts.forEach(opt => preloadModelFile(opt?.model_url));
    }
  }

  function handleSelectionChange(stepIdx) {
    if (typeof onSelectionChange === 'function') {
      onSelectionChange(currentSelections, stepIdx);
    }

    applyCameraFocus(stepIdx);

    preloadUpcomingModels(stepIdx);
  }

  function renderOptions(stepIdx) {
    const field = stepFields[stepIdx];
    if (!field) {
      console.warn('renderOptions: Kein Feld für Index', stepIdx);
      return;
    }
    const stepConfig = steps[stepIdx];
    const options = (stepConfig && Array.isArray(stepConfig.options))
      ? stepConfig.options
      : [];
    const isPreviewStep = stepConfig?.group === PREVIEW_STEP_NAME || stepConfig?.type === 'preview';

    if (isPreviewStep) {
      if (!stepRenderCache.has(stepIdx)) {
        const previewTexts = translations.preview;
        field.innerHTML = `
          <div class="oryx-preview-step">
            <div class="oryx-preview-step-grid">
              <div class="oryx-preview-step-info">
                <h3 class="oryx-preview-step-title">${previewTexts.step_title}</h3>
                <p class="oryx-preview-step-text">${previewTexts.step_body}</p>
              </div>
              <div class="oryx-preview-step-actions">
                <div class="oryx-preview-actions">
                  <button type="submit" class="oryx-configurator-submit" form="oryx-configurator-form">
                    ${translate('controls.add_to_cart')}
                  </button>
                  <button type="button" class="oryx-preview-action-btn" data-preview-action="download">
                    <span class="oryx-preview-action-icon" aria-hidden="true">⬇</span>
                    <span>${previewTexts.download}</span>
                  </button>
                  <button type="button" class="oryx-preview-action-btn oryx-preview-action-btn--share" data-preview-action="share">
                    <span class="oryx-preview-action-icon" aria-hidden="true">✶</span>
                    <span>${previewTexts.share}</span>
                  </button>
                </div>
              </div>
            </div>
            <p class="oryx-preview-step-hint">${previewTexts.hint}</p>
          </div>
        `;

        const downloadBtn = field.querySelector('[data-preview-action="download"]');
        const shareBtn = field.querySelector('[data-preview-action="share"]');

        if (downloadBtn) {
          downloadBtn.addEventListener('click', async () => {
            downloadBtn.disabled = true;
            try {
              await downloadPreviewImage();
            } finally {
              setTimeout(() => {
                downloadBtn.disabled = false;
              }, 400);
            }
          });
        }

        if (shareBtn) {
          shareBtn.addEventListener('click', async () => {
            shareBtn.disabled = true;
            shareBtn.dataset.state = 'sharing';
            try {
              await sharePreviewImageOnInstagram();
            } finally {
              delete shareBtn.dataset.state;
              shareBtn.disabled = false;
            }
          });
        }

        stepRenderCache.set(stepIdx, { type: 'preview' });
      }
      return;
    }

    const currentSelection = currentSelections[stepIdx] || {};

    const cached = stepRenderCache.get(stepIdx);
    if (cached) {
      cached.cards.forEach(card => {
        const targetValue = currentSelection.value == null ? '' : String(currentSelection.value);
        const isActive = card.dataset.value === targetValue;
        card.classList.toggle('active', isActive);
        const title = card.querySelector('.oryx-card-title');
        if (title) {
          title.classList.toggle('highlight', isActive);
        }
      });

      if (cached.engravingInput) {
        cached.engravingInput.value = currentSelection.engravingText || '';
        cached.updateEngravingVisibility?.();
      }

      centerActiveCardOnMobile(cached.track);
      return;
    }

    field.innerHTML = '';
    const leftArrow = document.createElement('div');
    leftArrow.className = 'oryx-slider-arrow oryx-slider-left';
    leftArrow.textContent = '<';
    const track = document.createElement('div');
    track.className = 'oryx-card-track';
    const rightArrow = document.createElement('div');
    rightArrow.className = 'oryx-slider-arrow oryx-slider-right';
    rightArrow.textContent = '>';

    field.append(leftArrow, track, rightArrow);

    let engravingWrapper = null;
    let engravingInput = null;
    const cards = [];

    function updateEngravingVisibility() {
      if (!engravingWrapper) {
        return;
      }
      const selection = currentSelections[stepIdx];
      const showInput = selection?.engravingEnabled !== false;
      engravingWrapper.classList.toggle('oryx-engraving-hidden', !showInput);
      engravingWrapper.setAttribute('aria-hidden', showInput ? 'false' : 'true');
      if (engravingInput) {
        engravingInput.disabled = !showInput;
      }

      if (!showInput && engravingInput) {
        engravingInput.value = '';
        if (selection) {
          selection.engravingText = '';
        }
        updateShopifyProps(currentSelections);
      }
    }

    if (!Array.isArray(options) || options.length === 0) {
      track.innerHTML = `<p class="oryx-card-empty">${translate('empty_options')}</p>`;
      return;
    }

    const createCardTitle = (text) => {
      const titleEl = document.createElement('div');
      titleEl.className = 'oryx-card-title';
      titleEl.textContent = text;
      return titleEl;
    };

    options.forEach((opt, i) => {
      const card = document.createElement('div');
      const optionValue = typeof opt.value === 'undefined' ? '' : String(opt.value);
      const isActive = String(currentSelection.value) === optionValue;
      card.className = 'oryx-card-option' + (isActive ? ' active' : '');
      card.dataset.idx = i;
      card.dataset.value = optionValue;

      if (opt.img_card) {
        const img = document.createElement('img');
        img.src = opt.img_card;
        img.alt = '';
        card.appendChild(img);
      }

      const titleEl = createCardTitle(opt.value);
      if (isActive) {
        titleEl.classList.add('highlight');
      }
      card.appendChild(titleEl);

      card.addEventListener('click', () => {
        cards.forEach(c => {
          const title = c.querySelector('.oryx-card-title');
          const active = c === card;
          c.classList.toggle('active', active);
          title?.classList.toggle('highlight', active);
        });

        const previousText = currentSelections[stepIdx]?.engravingText || '';
        currentSelections[stepIdx] = {
          group: stepConfig.group,
          type: stepConfig.type,
          ...options[i]
        };
        if (stepConfig.type === 'engraving') {
          currentSelections[stepIdx].engravingText = previousText;
          updateEngravingVisibility();
        }
        updatePrice();
        handleSelectionChange(stepIdx);
        resetIdleRotationTimer(viewer);
        if (typeof updateEngravingPreview === 'function' && typeof viewer !== 'undefined') {
          updateEngravingPreview(viewer, currentSelections);
        }

        if (window.innerWidth <= 768) {
          centerActiveCardOnMobile(track);
        }
      });

      cards.push(card);
      track.appendChild(card);
    });

    const scrollAmt = 240;
    leftArrow.onclick = () => track.scrollBy({ left: -scrollAmt, behavior: 'smooth' });
    rightArrow.onclick = () => track.scrollBy({ left: +scrollAmt, behavior: 'smooth' });

    if (stepConfig?.type === 'engraving') {
      engravingWrapper = document.createElement('label');
      engravingWrapper.className = 'oryx-engraving-input-wrapper';
      engravingWrapper.textContent = stepConfig.inputLabel || translate('engraving.label');

      engravingInput = document.createElement('input');
      engravingInput.type = 'text';
      engravingInput.className = 'oryx-engraving-input';
      engravingInput.placeholder = stepConfig.placeholder || 'Max. 20 Zeichen';
      if (stepConfig.maxLength) {
        engravingInput.maxLength = stepConfig.maxLength;
      }
      engravingInput.value = currentSelections[stepIdx].engravingText || '';
      engravingInput.addEventListener('input', event => {
        currentSelections[stepIdx].engravingText = event.target.value;
        updateShopifyProps(currentSelections);
        resetIdleRotationTimer(viewer);
        if (typeof updateEngravingPreview === 'function' && typeof viewer !== 'undefined') {
          updateEngravingPreview(viewer, currentSelections);
        }
      });

      engravingWrapper.appendChild(engravingInput);
      field.appendChild(engravingWrapper);
      updateEngravingVisibility();
    }

    stepRenderCache.set(stepIdx, {
      cards,
      track,
      engravingInput,
      updateEngravingVisibility,
      type: 'options'
    });

    centerActiveCardOnMobile(track);
  }

  function updatePrice() {
    const resolvedPricing = resolveVariantPricing(pricingConfig, currentSelections);
    const baseCents = Number.isFinite(resolvedPricing.priceCents)
      ? resolvedPricing.priceCents
      : 0;
    const effectiveBaseCents = baseCents || basePriceCents;
    const surchargeCents = 0;
    const totalCents = effectiveBaseCents + surchargeCents;
    if (priceDisplay) {
      priceDisplay.textContent = formatMoney(totalCents);
    }
    if (typeof onPriceChange === 'function') {
      onPriceChange({
        selections: currentSelections.map(sel => ({ ...sel })),
        surchargeCents,
        totalCents,
        variantId: resolvedPricing.variantId,
        basePriceCents: effectiveBaseCents
      });
    }
  }

  function showStep(n) {
    currentStepIdx = n;
    stepFields.forEach((f, i) => f.classList.toggle('active', i === n));
    stepBar.forEach((b, i)  => b.classList.toggle('oryx-active', i === n));
    renderOptions(n);
    handleSelectionChange(n);
    resetIdleRotationTimer(viewer);
    updatePrice();

    if (window.innerWidth <= 768) {
      smoothCenterScroll(document.getElementById('oryx-progress-steps'), stepBar[n]);
      smoothCenterScroll(document.getElementById('oryx-step-fields'), stepFields[n]);
    }
  }

  stepBar.forEach((el, i) => el.addEventListener('click', () => showStep(i)));

  stepFields.forEach((f, i) => f.classList.toggle('active', i === 0));
  renderOptions(0);
  handleSelectionChange(0);
  updatePrice();

  if (window.innerWidth <= 768) {
    smoothCenterScroll(document.getElementById('oryx-progress-steps'), stepBar[0]);
    smoothCenterScroll(document.getElementById('oryx-step-fields'), stepFields[0]);
    centerActiveCardOnMobile(stepRenderCache.get(0)?.track);
  }
}


// ===========================================
// MAIN (Orchestrator)
// ===========================================
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded: initUI & initBabylonViewer');
  const steps = getSteps();
  preloadCardImages(steps);
  const pricingData = getPricingData();
  if (pricingData) {
    pricingState.basePriceCents = Number(pricingData.basePriceCents) || 0;
    pricingState.activeBasePriceCents = pricingState.basePriceCents;
    pricingState.variantId = pricingData.baseVariantId || null;
  }
  const currencyCode = pricingData?.currency || window.Shopify?.currency?.active || 'EUR';
  const locale = pricingData?.locale || document.documentElement.lang || 'de-DE';
  const formatMoney = createMoneyFormatter(currencyCode, locale);

  viewer = initBabylonViewer();
  setupPreviewControls(viewer);
  setupMobileFullscreenHint();

  initUI(steps, {
    basePriceCents: pricingState.basePriceCents,
    pricingConfig: pricingData,
    formatMoney,
    onSelectionChange: (currentSelections, currentStepIdx) => {
      const activeGroup = steps[currentStepIdx]?.group;
      const summary = updateShopifyProps(currentSelections);
      pricingState.selections = currentSelections.map(sel => ({ ...sel }));
      pricingState.summary = summary || buildSelectionSummary(currentSelections);

      if (!viewer) {
        return;
      }

      for (let i = 0; i <= currentStepIdx; i++) {
        const sel = currentSelections[i];
        console.log('Loading model:', sel.group, sel.model_url); // Debugging
        showPart(viewer, sel.group, sel.model_url);
      }
      updateEngravingPreview(viewer, currentSelections);
    },
    onPriceChange: ({ surchargeCents, totalCents, variantId, basePriceCents: activeBasePriceCents }) => {
      pricingState.surchargeCents = surchargeCents;
      pricingState.totalCents = totalCents;
      pricingState.activeBasePriceCents = typeof activeBasePriceCents === 'number'
        ? activeBasePriceCents
        : pricingState.activeBasePriceCents;
      pricingState.variantId = variantId || pricingData?.baseVariantId || pricingState.variantId;
      updatePricePropertyDisplay(formatMoney(totalCents), totalCents);
      const variantInput = document.getElementById('oryx-variant-id');
      if (variantInput && pricingState.variantId) {
        variantInput.value = pricingState.variantId;
      }
    }
  });

  setupConfiguratorForm(pricingData);
  console.log('UI initialisiert.');
});
